import { SUPPORTED_RESOLUTIONS } from "../datafeed/datafeed";
import { CHART_TYPE_AREA } from "../constants";

// The month time frame is not offered in the chart menu
const MONTH_RESOLUTION = "M";

/** Time frames of the chart menu. */
export const CHART_RESOLUTIONS = SUPPORTED_RESOLUTIONS.filter(
  (resolution) => resolution !== MONTH_RESOLUTION,
);

// Line (Area) chart always runs on the smallest interval, like in PO.
export const LINE_RESOLUTION = CHART_RESOLUTIONS[0];

export const isLineChart = (chartType) => chartType === CHART_TYPE_AREA;

/**
 * Settings the chart actually runs with. The saved settings stay untouched,
 * so leaving Line restores the saved resolution and timer.
 * On Line: smallest resolution, no bar countdown timer.
 *
 * @param {object} settings - saved chart settings
 * @returns {object}
 */
const getEffectiveChartSettings = (settings) => {
  if (!isLineChart(settings.chartType)) return settings;

  return { ...settings, resolution: LINE_RESOLUTION, timerEnabled: false };
};

export default getEffectiveChartSettings;
